export enum BudgetCounterproposal {
  SINGLE_COUNTERPROPOSAL = "SINGLE_COUNTERPROPOSAL",
  DOUBLE_COUNTERPROPOSAL = "DOUBLE_COUNTERPROPOSAL"
}
